module.exports = __webpack_public_path__ + "static/media/0017.fb2bdd47.svg";